import * as general from './general'
import $ from 'jquery'

export function validForm(formName, viewAlert = false) {
    let newform = $(`form[name="${formName}"]`)[0]
    // console.log("each newform---->>>", newform)
    if (newform) {
        for (let element of newform) {
            if (element.name) {
                // console.log("element--->", element.name);
                element.setAttribute("title", '');
                element.addEventListener('invalid', (e) => eventSubmit(e, viewAlert), false);
                element.addEventListener('keypress', () => removeElement(element.name));
                element.addEventListener('change', () => removeElement(element.name));
            }
        }
    }
}

function eventSubmit(e, viewAlert) {
    e.preventDefault()

    // if (viewAlert) openCloseAlertForm(true)

    const elementoAnterior = e.target
    elementoAnterior.setAttribute("title", '');

    const nameError = 'error' + elementoAnterior.name
    removeElement(elementoAnterior.name)
    let nuevoElemento = document.createElement('span');
    nuevoElemento.setAttribute("name", nameError);
    nuevoElemento.className = 'errorField '


    if (elementoAnterior.validity.badInput) {
        nuevoElemento.appendChild(document.createTextNode(general.MESSAGE_BAD_INPUT));
        // elementoAnterior.setAttribute("title", MESSAGE_BAD_INPUT);
        elementoAnterior.setAttribute("title", '');
        elementoAnterior.parentNode.insertBefore(nuevoElemento, elementoAnterior.nextSibling);
    } else if (elementoAnterior.validity.valueMissing) {
        nuevoElemento.appendChild(document.createTextNode(general.INPUT_MESSAGE_REQUERID));
        
        elementoAnterior.setAttribute("title", '');
        // elementoAnterior.parentNode.insertBefore(nuevoElemento, elementoAnterior.nextSibling);
        
        if($(elementoAnterior).is("select")){
            elementoAnterior.parentNode.parentNode.insertBefore(nuevoElemento, elementoAnterior.nextSibling);
        }else if(elementoAnterior.type === "checkbox"){
            $(nuevoElemento).insertAfter(elementoAnterior.parentNode)
        }else{
            elementoAnterior.parentNode.insertBefore(nuevoElemento, elementoAnterior.nextSibling);
        }

    } else if (elementoAnterior.validity.typeMismatch) {
        if (elementoAnterior.type === "email") {
            nuevoElemento.appendChild(document.createTextNode(general.EMAIL_MESSAGE_FORMAT));
            // elementoAnterior.setAttribute("title", EMAIL_MESSAGE_FORMAT);
            elementoAnterior.setAttribute("title", '');
            elementoAnterior.parentNode.insertBefore(nuevoElemento, elementoAnterior.nextSibling);
        } else {
            nuevoElemento.appendChild(document.createTextNode(general.MESSAGE_TYPE_INVALID));
            // elementoAnterior.setAttribute("title", MESSAGE_TYPE_INVALID);
            elementoAnterior.setAttribute("title", '');
            elementoAnterior.parentNode.insertBefore(nuevoElemento, elementoAnterior.nextSibling);
        }
    } else if (elementoAnterior.validity.patternMismatch) {
        const formato = elementoAnterior.dataset.pattern ? elementoAnterior.dataset.pattern : ''
        nuevoElemento.appendChild(document.createTextNode(general.PATTERN_MESSAGE + formato));
        // elementoAnterior.setAttribute("title", PATTERN_MESSAGE + formato);
        elementoAnterior.setAttribute("title", '');
        elementoAnterior.parentNode.insertBefore(nuevoElemento, elementoAnterior.nextSibling);
    } else if (elementoAnterior.validity.tooLong) {
        nuevoElemento.appendChild(document.createTextNode(general.MESSAGE_TOO_LONG.replace("$value", elementoAnterior.maxLength)));
        // elementoAnterior.setAttribute("title", MESSAGE_TOO_LONG.replace("$value", elementoAnterior.maxLength));
        elementoAnterior.setAttribute("title", '');
        elementoAnterior.parentNode.insertBefore(nuevoElemento, elementoAnterior.nextSibling);
    } else if (elementoAnterior.validity.tooShort) {
        nuevoElemento.appendChild(document.createTextNode(general.MESSAGE_TOO_SHORT.replace("$value", elementoAnterior.minLength)));
        // elementoAnterior.setAttribute("title", MESSAGE_TOO_SHORT.replace("$value", elementoAnterior.minLength));
        elementoAnterior.setAttribute("title", '');
        elementoAnterior.parentNode.insertBefore(nuevoElemento, elementoAnterior.nextSibling);
    } else if (elementoAnterior.validity.rangeOverflow) {
        nuevoElemento.appendChild(document.createTextNode(general.MESSAGE_RANGE_MAX.replace("$value", elementoAnterior.max)));
        // elementoAnterior.setAttribute("title", MESSAGE_RANGE_MAX.replace("$value", elementoAnterior.max));
        elementoAnterior.setAttribute("title", '');
        elementoAnterior.parentNode.insertBefore(nuevoElemento, elementoAnterior.nextSibling);
    } else if (elementoAnterior.validity.rangeUnderflow) {
        nuevoElemento.appendChild(document.createTextNode(general.MESSAGE_RANGE_MIN.replace("$value", elementoAnterior.min)));
        // elementoAnterior.setAttribute("title", MESSAGE_RANGE_MIN.replace("$value", elementoAnterior.min));
        elementoAnterior.setAttribute("title", '');
        elementoAnterior.parentNode.insertBefore(nuevoElemento, elementoAnterior.nextSibling);
    } else if (elementoAnterior.validity.stepMismatch) {
        nuevoElemento.appendChild(document.createTextNode(general.MESSAGE_STEP));
        // elementoAnterior.setAttribute("title", MESSAGE_STEP.replace("$value", elementoAnterior.step));
        elementoAnterior.setAttribute("title", '');
        elementoAnterior.parentNode.insertBefore(nuevoElemento, elementoAnterior.nextSibling);
    } else {
        nuevoElemento.appendChild(document.createTextNode(general.MESSAGE_INVALID));
        // elementoAnterior.setAttribute("title", MESSAGE_INVALID);
        elementoAnterior.setAttribute("title", '');
        elementoAnterior.parentNode.insertBefore(nuevoElemento, elementoAnterior.nextSibling);
    }
    elementoAnterior.focus()
    // elementoAnterior.type = ""
    // console.log("elementoAnterior---->", e, elementoAnterior.name, elementoAnterior.validity)

}

function removeElement(name) {
    let nameError = 'error' + name
    let node = document.getElementsByName(nameError)[0]
    if (node) {
        let element = document.getElementsByName(name)[0]
        element.title = ""
        node.remove();
    }
}